import {useMemo} from 'react'

import {GetServerSideProps} from 'next'
import dynamic from 'next/dynamic'

import SEO from 'components/elements/SEO'
import LayoutPaystub from 'components/layouts/LayoutPaystub'
import {TPageComponent} from 'src/types'
import experiments from 'src/utils/experiments'
import {useExperiment} from 'src/utils/hooks/useExperiment'

const TemplateCreateDocumentPayStub = dynamic(
	() => import('components/templates/TemplateCreateDocumentPayStub'),
)
const TemplateCreateDocumentPayStubNew = dynamic(
	() => import('components/templates/TemplateCreateDocumentPayStubNew'),
)

interface IPaystubProps {
	flagValue: 'control' | 'old'
}

const PayStub: TPageComponent<IPaystubProps> = ({flagValue}) => {
	useExperiment(experiments.redesignedBuilder.id)

	const Template = useMemo(
		() => (flagValue === 'old' ? TemplateCreateDocumentPayStub : TemplateCreateDocumentPayStubNew),
		[flagValue],
	)

	return (
		<>
			<SEO
				keywords="paystub generator"
				title="Online Paystub Generator | Best Paycheck Maker - Paystub.org"
				description="Instantly create a paystub using this online paystub generator. Choose your template, input your details, review, and download your fresh paycheck."
			/>
			<Template />
		</>
	)
}

PayStub.displayName = 'PayStub'
PayStub.Layout = LayoutPaystub

export default PayStub

export const getServerSideProps: GetServerSideProps = async ({query}) => {
	const flagValue = query?.flagValue || 'control'
	return {
		props: {flagValue},
	}
}
